export const Underwriters = () => {
  return (
    <section id="underwriters" className="py-16 lg:py-20 bg-white" data-testid="underwriters-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <p className="text-center text-xs font-bold uppercase tracking-widest text-[#64748B] mb-8">
          Proudly Underwritten By
        </p>
        <div className="flex flex-wrap justify-center items-center gap-12 md:gap-20">
          <div className="flex flex-col items-center" data-testid="underwriter-first-american">
            <img
              src="https://customer-assets.emergentagent.com/job_closing-pros/artifacts/dphzwrxi_First%20American%20Logo.jpg"
              alt="First American Title Insurance Company"
              className="h-16 md:h-20 w-auto rounded-lg hover:scale-105 transition-transform"
            />
          </div>
          <div className="flex flex-col items-center" data-testid="underwriter-fidelity">
            <img
              src="https://customer-assets.emergentagent.com/job_closing-pros/artifacts/1yvypi3w_Fidelity%20Logo.jpg"
              alt="Fidelity National Title"
              className="h-16 md:h-20 w-auto hover:scale-105 transition-transform"
            />
          </div>
        </div>
      </div>
    </section>
  );
};
